export default "__VITE_ASSET__DELpSxuL__"